import { IonButton, IonIcon, IonText } from '@ionic/react';
import { arrowForward } from 'ionicons/icons';
import { useSwiper } from 'swiper/react';
import Trans from 'util/Trans';

interface OnboardingSlideProps {
  imageUrl?: string;
  title?: string | React.ReactNode;
  description?: string | React.ReactNode;
  hasNextButton?: boolean;
  buttons?: React.ReactNode;
}

const Slide = (props: OnboardingSlideProps) => {
  const { title, description, imageUrl, buttons, hasNextButton } = props;
  const swiper = useSwiper();

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateRows: '3fr 2fr 1fr',
        paddingBottom: '64px',
        height: '100%',
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <div
        style={{
          background: 'none',
          paddingLeft: '32px',
          paddingRight: '32px',
        }}
      >
        <img
          alt="SlideHeader"
          src={imageUrl}
          style={{ objectFit: 'contain', height: '100%', width: '100%' }}
        />
      </div>
      <div style={{ padding: '32px', textAlign: 'center' }}>
        <IonText style={{ fontSize: '21px' }}>
          <b>{title}</b>
        </IonText>
        <br />
        <br />
        <IonText>{description}</IonText>
      </div>
      <div
        style={{
          padding: '16px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'end',
        }}
      >
        {buttons}
        {hasNextButton && (
          <IonButton
            expand="block"
            fill="outline"
            color="dark"
            style={{ borderRadius: 0 }}
            size="default"
            onClick={() => swiper.slideNext()}
          >
            <Trans i18nKey="PROCEED">Weiter</Trans>
            <IonIcon icon={arrowForward} slot="end" />
          </IonButton>
        )}
      </div>
    </div>
  );
};

export default Slide;
